import React, { Component } from 'react';
import Blogs from '../../../../PublicView/Pages/EndUser/Blog/Blogs';
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import Slider from "react-slick";
import axios from 'axios'
import SpanSpinner from '../../../../Shared/SpanSpinner/SpanSpinner';
import './Blogs.scss';
import { ROOT_API_URL } from "../../../../../api-config";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

//[
//    {
//        "title": "This is a second post",
//        "link": "https://member.tscra.org/this-is-a-second-post/",
//        "id": "https://member.tscra.org/?p=628",
//        "description": "This is much more lengthy of a post, Lets see what all I can get in here.&#160;This is much more lengthy of a post, Lets see what all I can get in here.&#160;This is much more lengthy of a post, &#8230; Continued",
//        "story": "<p>This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;This is much more lengthy of a post, Lets see what all I can get in here.&nbsp;</p>\n",
//        "categories": [
//            "Uncategorized"
//        ]
//    },
//    {
//        "title": "This is the first Test POst",
//        "link": "https://member.tscra.org/this-is-the-first-test-post/",
//        "id": "https://member.tscra.org/?p=626",
//        "description": "Here is some test text",
//        "story": "<p>Here is some test text</p>\n",
//        "categories": [
//            "Digital Archive",
//            "Uncategorized"
//        ]
//    }
//]

class BlogHome extends Component {
    constructor(props) {
        super(props);

        this.state = {
            events: null,
            categories: null
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
    this.setState({ isOpen: !this.state.isOpen });
    }


    componentDidMount() {
        this.getFeed();
    }

    getFeed = () => {
        axios.get(`${ROOT_API_URL}/Posts/Feed`)
        .then(res => {
            var uniqueArray = [];
            res.data.forEach(function (element) {
                element.categories.forEach(function (category) {
                    if (uniqueArray.indexOf(category) === -1) {
                        uniqueArray.push(category);
                    }
                })
            });

            console.log(res.data)
            this.setState({
                events: res.data,
                categories: uniqueArray
            });

        });
    }

    getFeedByCategory = (category) => {
        category = category.replace(/ /g, "-");
        axios.get(`${ROOT_API_URL}/Posts/CategoryFeed`, {
            params: {
                categoryName: category
            }
        })
        .then(res => {
            this.setState({ events: res.data });
        });

    }

    GetNav() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <header className="blogNav">
                <div>
                    <Navbar light expand="lg">
                        <NavbarBrand tag={Link} to="/store">
                            <img src="/images/storeLogo.png" className="storeLogo" alt="Store Logo" />
                        </NavbarBrand>
                        <NavbarToggler onClick={this.toggle} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="mr-auto" navbar>
                                <NavItem onClick={() => { this.getFeed() }} >
                                    <NavLink tag={RouterNavLink}
                                        className={this.props.location.pathname === "/blog/" || this.props.location.pathname === "/blog" ? 'active' : 'notActive'}
                                        to={"/blog/"}>
                                        All
                                    </NavLink>
                                </NavItem>
                                {this.state.categories ?
                                    this.state.categories.map((category, index) => {
                                        return (
                                            // <NavItem onClick={() => this.getFeedByCategory(category)} key={index} >
                                            //     {category}
                                            // </NavItem>
                                            <NavItem onClick={() => { this.getFeedByCategory(category) }} key={index} >
                                                <NavLink tag={RouterNavLink}
                                                    className={this.props.location.pathname === "/blog/"  + category ? 'active' : ''}
                                                    to={"/blog/" + category + "?categoryId=" + category}>
                                                    {category}
									            </NavLink>
                                            </NavItem>
                                        )
                                    }) : null
                                }
                            </Nav>
                        </Collapse>
                    </Navbar>
                </div>

                <div className="storeSlider">
                    <Slider {...settings}>
                        <div className="storeSingleSlider cols">
                            <div className="col-left">
                            </div>
                            <div className="col-right">
                                <h3 className="storeSliderTitle">Resources</h3>
                                <p className="storeSliderText">Resources for TSCRA members.</p>
                            </div>
                        </div>
                    </Slider>
                </div>
            </header>
        );
    }

    render() {
        return (
            <div className="blogPage">
                <div>{this.GetNav()}</div>
                <div className="container">
                    <div className="">
                        <h1 className="blogTitle">
                            Resources 
                        </h1>
                    </div>
                     
                            {
                                this.state.events ?
                                <div className="row blogPage-row">
                                    {
                                        this.state.events.map((item, index) =>
                                            <Blogs item={item} key={index} />)
                                        }
                                </div>
                                 :
                                <SpanSpinner message="Loading Resources..." />
                            }
                        
                </div>
            </div>
        );
    }
}

export default withRouter(connect(null, {})(BlogHome));

